
import React from "react";

import Header from "../global/header";
import Footer from "../global/footer";
import Breadcrumbs from "../breadcrumbs";
import SingleBlogs from "../single-blogs";

const SingleBlog = ({ headerv3, footer}) => {
  const { menuv3 } = footer;

  return (
    <>
      <Header header={headerv3} />
      {/* <Breadcrumbs isBg="yes" title="Single Blog" />  */}
      <div><section
      id="media"
      className={`section-padding bg-one`}
      style={{padding:"100px 0 0 0"}}
    >
      <div className="container">
        <div className="row">
          <div className="col-xl-6 offset-xl-3 col-lg-10 offset-lg-1">
            <div className="section-title-center text-center">

            </div>
          </div>
        </div>

          </div>
    </section></div>
      <SingleBlogs isBg="yes"/>
      <Footer isBg="yes" menu={menuv3} />
    </>
  );
};

export default SingleBlog;
